/* ============================================================
   FIND YOUR EDIT QUIZ – Seoul Beauty Edit
   Client-side quiz logic and Shopify Cart integration
   ============================================================ */

(function() {
  'use strict';

  /* ---- Data: Edit Bundles ---- */
  var EDITS = {
    minimalist: {
      name: 'THE MINIMALIST EDIT',
      tag: 'A streamlined routine that does everything your skin actually needs.',
      desc: 'Built for those who want clarity, not complexity. If your routine feels crowded, inconsistent, or harder than it should be, this Edit strips things back to the essentials that actually make a difference. Each step is chosen to do its job well and layer seamlessly, giving your skin everything it needs and nothing it doesn\'t.',
      bundleHandle: 'the-minimalist-edit-1',
      bundleVariantId: 47658601316569,
      products: [
        { step: 1, role: 'CLEANSE', name: 'ROUND LAB 1025 DOKDO CLEANSER', handle: 'round-lab-1025-dokdo-cleanser', variantId: 46660941906137, note: 'Low-pH, barrier-friendly, works every time.' },
        { step: 2, role: 'HYDRATE', name: "I'M FROM RICE TONER", handle: 'i-m-from-rice-toner', variantId: 46660947247321, note: 'Bi-phase formula that softens without heaviness.' },
        { step: 3, role: 'TREAT', name: 'BEAUTY OF JOSEON GLOW SERUM', handle: 'beauty-of-joseon-glow-serum-propolis-niacinamide', variantId: 46660965761241, note: 'Propolis + niacinamide for calm, even skin.' },
        { step: 4, role: 'MOISTURIZE', name: 'COSRX ADVANCED SNAIL 92 CREAM', handle: 'cosrx-advanced-snail-92-all-in-one-cream', variantId: 46654178722009, note: 'Cushiony hydration that layers without pilling.' },
        { step: 5, role: 'PROTECT', name: 'BEAUTY OF JOSEON RELIEF SUN', handle: 'beauty-of-joseon-relief-sun-rice-probiotics', variantId: 46660968710361, note: 'SPF that feels like skincare, not sunscreen.' }
      ]
    },
    glow: {
      name: 'THE GLOW EDIT',
      tag: 'Brightness, clarity, and radiance in every step.',
      desc: 'Designed for skin that looks dull, uneven, or a little tired, even when you\'re doing all the right things. This Edit focuses on gentle brightening, deep hydration, and consistent layering so results build over time rather than overwhelm your skin. Every product works toward clarity and luminosity without compromising barrier health.',
      bundleHandle: 'the-glow-edit-1',
      bundleVariantId: 47660986958041,
      products: [
        { step: 1, role: 'FIRST CLEANSE', name: 'BANILA CO CLEAN IT ZERO', handle: 'banila-co-clean-it-zero-cleansing-balm', variantId: 46656238682329, note: 'Sherbet-to-oil that melts everything away.' },
        { step: 2, role: 'SECOND CLEANSE', name: 'ROUND LAB 1025 DOKDO CLEANSER', handle: 'round-lab-1025-dokdo-cleanser', variantId: 46660941906137, note: 'Low-pH follow-up for a perfectly clean canvas.' },
        { step: 3, role: 'TONE', name: 'NUMBUZIN NO.3 ESSENCE TONER', handle: 'numbuzin-no-3-super-glowing-essence-toner', variantId: 46660949410009, note: '50 fermented ingredients for quiet radiance.' },
        { step: 4, role: 'BRIGHTEN', name: 'GOODAL VITA C SERUM', handle: 'goodal-green-tangerine-vita-c-serum', variantId: 46660961435865, note: 'Vitamin C that brightens without irritation.' },
        { step: 5, role: 'HYDRATE', name: 'TORRIDEN DIVE-IN SERUM', handle: 'torriden-dive-in-serum', variantId: 46655839076569, note: '5D hyaluronic acid, weightless hydration.' },
        { step: 6, role: 'MOISTURIZE', name: 'ROUND LAB BIRCH JUICE CREAM', handle: 'round-lab-birch-juice-moisturizing-cream', variantId: 46660953604313, note: 'Lightweight finish that seals in glow.' },
        { step: 7, role: 'PROTECT', name: 'ROUND LAB BIRCH JUICE SUNSCREEN', handle: 'round-lab-birch-juice-sunscreen', variantId: 46660970578137, note: 'SPF that blends invisibly, no white cast.' }
      ]
    },
    futureProof: {
      name: 'THE FUTURE-PROOF EDIT',
      tag: 'Resilience, firmness, and radiance that builds over time.',
      desc: 'For skin starting to show early signs of aging or simply not holding onto its structure the way it used to. This Edit combines hydration, firming support, and tone-evening ingredients in a way that prioritizes long-term skin health over quick fixes. The formulas are chosen to work together daily, strengthening the skin so it stays resilient, smooth, and balanced over time.',
      bundleHandle: 'the-future-proof-edit-1',
      bundleVariantId: 47658616062169,
      products: [
        { step: 1, role: 'CLEANSE', name: 'ROUND LAB 1025 DOKDO CLEANSER', handle: 'round-lab-1025-dokdo-cleanser', variantId: 46660941906137, note: 'Gentle daily cleanser that protects your barrier.' },
        { step: 2, role: 'TONE', name: "I'M FROM RICE TONER", handle: 'i-m-from-rice-toner', variantId: 46660947247321, note: 'Rice extract that softens and nourishes.' },
        { step: 3, role: 'TREAT', name: 'MEDICUBE PDRN PINK PEPTIDE SERUM', handle: 'medicube-pdrn-pink-peptide-serum', variantId: 47313148510425, note: 'PDRN + peptides for elasticity support.' },
        { step: 4, role: 'HYDRATE', name: 'TORRIDEN DIVE-IN SERUM', handle: 'torriden-dive-in-serum', variantId: 46655839076569, note: 'Multi-weight hyaluronic acid, zero heaviness.' },
        { step: 5, role: 'MOISTURIZE', name: 'MEDICUBE TRIPLE COLLAGEN CREAM', handle: 'medicube-triple-collagen-cream', variantId: 46802208817369, note: 'Collagen + elastin for visible resilience.' },
        { step: 6, role: 'PROTECT', name: 'BEAUTY OF JOSEON RELIEF SUN', handle: 'beauty-of-joseon-relief-sun-rice-probiotics', variantId: 46660968710361, note: 'Hydrating SPF to finish with care.' }
      ]
    },
    repair: {
      name: 'THE REPAIR EDIT',
      tag: 'Deep barrier support for skin that needs to recover.',
      desc: 'Built for skin that\'s been pushed too far, whether from over-exfoliation, sensitivity, or routines that did too much. This Edit removes anything that could trigger further stress and focuses entirely on calming, replenishing, and rebuilding the barrier. Each product is selected for its ability to support recovery quietly and consistently, without interference.',
      bundleHandle: 'the-repair-edit-1',
      bundleVariantId: 47661091422425,
      products: [
        { step: 1, role: 'CLEANSE', name: 'ROUND LAB 1025 DOKDO CLEANSER', handle: 'round-lab-1025-dokdo-cleanser', variantId: 46660941906137, note: "Won't disrupt what you're trying to heal." },
        { step: 2, role: 'TONE', name: "I'M FROM RICE TONER", handle: 'i-m-from-rice-toner', variantId: 46660947247321, note: 'Calm, nourishing base for recovery.' },
        { step: 3, role: 'TREAT', name: 'SKIN1004 CENTELLA AMPOULE', handle: 'skin1004-madagascar-centella-ampoule', variantId: 46802204950745, note: 'Pure centella in a minimal formula.' },
        { step: 4, role: 'HYDRATE', name: 'TORRIDEN DIVE-IN SERUM', handle: 'torriden-dive-in-serum', variantId: 46655839076569, note: 'Gentle hydration that calms, not coats.' },
        { step: 5, role: 'MOISTURIZE', name: 'ILLIYOON CERAMIDE ATO CREAM', handle: 'illiyoon-ceramide-ato-concentrate-cream', variantId: 46660956750041, note: 'Ceramide barrier repair, genuinely effective.' },
        { step: 6, role: 'PROTECT', name: 'BEAUTY OF JOSEON RELIEF SUN', handle: 'beauty-of-joseon-relief-sun-rice-probiotics', variantId: 46660968710361, note: 'Soothing SPF for sensitive days.' }
      ]
    },
    reset: {
      name: 'THE RESET EDIT',
      tag: 'Start fresh with a routine that clears and rebalances.',
      desc: "For when your skin feels off, but not quite damaged: congested, unbalanced, or just not at its best. This Edit brings everything back to baseline with lightweight hydration, gentle brightening, and barrier support that won't overwhelm. The combination is intentional. Enough to refresh and rebalance without introducing unnecessary complexity.",
      bundleHandle: 'the-reset-edit-1',
      bundleVariantId: 47661076676825,
      products: [
        { step: 1, role: 'CLEANSE', name: 'ROUND LAB 1025 DOKDO CLEANSER', handle: 'round-lab-1025-dokdo-cleanser', variantId: 46660941906137, note: 'A dependable daily reset for your skin.' },
        { step: 2, role: 'TONE', name: 'NUMBUZIN NO.3 ESSENCE TONER', handle: 'numbuzin-no-3-super-glowing-essence-toner', variantId: 46660949410009, note: 'Fermented extracts to refresh and prep.' },
        { step: 3, role: 'HYDRATE', name: 'TORRIDEN DIVE-IN SERUM', handle: 'torriden-dive-in-serum', variantId: 46655839076569, note: 'Replenishes moisture without weight.' },
        { step: 4, role: 'MOISTURIZE', name: 'ROUND LAB BIRCH JUICE CREAM', handle: 'round-lab-birch-juice-moisturizing-cream', variantId: 46660953604313, note: 'Birch sap for balanced, comfortable skin.' },
        { step: 5, role: 'PROTECT', name: 'ROUND LAB BIRCH JUICE SUNSCREEN', handle: 'round-lab-birch-juice-sunscreen', variantId: 46660970578137, note: 'Lightweight SPF that finishes clean.' }
      ]
    }
  };

  /* ---- Data: Questions ---- */
  var QUESTIONS = [
    {
      q: 'HOW WOULD YOU DESCRIBE YOUR SKIN?',
      sub: 'Think about how it typically feels, not just today.',
      opts: [
        { l: 'Oily or congestion-prone', sc: { glow: 2, reset: 1 } },
        { l: 'Combination', sc: { minimalist: 2, glow: 1 } },
        { l: 'Normal, generally balanced', sc: { minimalist: 2, glow: 1 } },
        { l: 'Dry or dehydrated', sc: { repair: 2, futureProof: 1 } },
        { l: 'Mature or losing firmness', sc: { futureProof: 3 } },
        { l: 'Sensitive or easily reactive', sc: { repair: 2, minimalist: 1 } }
      ]
    },
    {
      q: 'WHAT MATTERS MOST TO YOU RIGHT NOW?',
      sub: 'Choose the one that feels most pressing.',
      opts: [
        { l: 'A simple routine that just works', sc: { minimalist: 3 } },
        { l: 'Brighter, more even-looking skin', sc: { glow: 3 } },
        { l: 'Calming irritation and rebuilding my barrier', sc: { repair: 3 } },
        { l: 'Firmer skin and fewer visible fine lines', sc: { futureProof: 3 } },
        { l: 'Clearing out the old and starting fresh', sc: { reset: 3 } }
      ]
    },
    {
      q: 'HOW DOES YOUR SKIN FEEL AT THE END OF THE DAY?',
      sub: 'Before you wash your face.',
      opts: [
        { l: 'Tight, flaky, or uncomfortable', sc: { repair: 2, futureProof: 1 } },
        { l: 'Shiny, congested, or clogged', sc: { glow: 2, reset: 1 } },
        { l: 'Comfortable but a bit flat or dull', sc: { minimalist: 2, glow: 1 } },
        { l: 'Fine, but I notice lines more than I used to', sc: { futureProof: 3 } },
        { l: 'Uneven. Some areas dry, some oily', sc: { reset: 2, minimalist: 1 } }
      ]
    },
    {
      q: "WHAT'S YOUR RELATIONSHIP WITH SKINCARE?",
      sub: "There's no wrong answer here.",
      opts: [
        { l: 'Keep it quick. Five minutes, tops', sc: { minimalist: 3, reset: 1 } },
        { l: "I enjoy the ritual. It's my self-care moment", sc: { glow: 2, futureProof: 2 } },
        { l: 'I want something gentle while my skin recovers', sc: { repair: 3 } },
        { l: "I've tried too much. I need to simplify", sc: { reset: 3 } }
      ]
    },
    {
      q: 'DO YOU USE ACTIVES LIKE RETINOIDS OR EXFOLIATING ACIDS?',
      sub: 'This helps us calibrate your routine.',
      opts: [
        { l: 'Yes, regularly', sc: { futureProof: 2, glow: 1 } },
        { l: 'Occasionally, when I remember', sc: { glow: 2, minimalist: 1 } },
        { l: 'No, I prefer to keep things gentle', sc: { repair: 2, minimalist: 1 } },
        { l: "I used to, but my skin couldn't handle it", sc: { repair: 3 } }
      ]
    },
    {
      q: "WHAT'S FRUSTRATED YOU MOST ABOUT SKINCARE?",
      sub: 'We hear these a lot.',
      opts: [
        { l: "Too many products and I don't know what works", sc: { minimalist: 3 } },
        { l: 'My skin looks dull no matter what I try', sc: { glow: 3 } },
        { l: 'Products seem to irritate more than they help', sc: { repair: 3 } },
        { l: "I can see my skin aging and don't know how to address it", sc: { futureProof: 3 } },
        { l: "I've accumulated too many products with no real routine", sc: { reset: 3 } }
      ]
    },
    {
      q: 'WHAT WOULD THE IDEAL ROUTINE FEEL LIKE?',
      sub: 'Not what it does. How it feels.',
      opts: [
        { l: 'Effortless. Like I barely did anything but my skin looks great.', sc: { minimalist: 3 } },
        { l: 'Luminous. Like my skin is glowing from within.', sc: { glow: 3 } },
        { l: 'Calm. Like my skin finally stopped fighting me.', sc: { repair: 3 } },
        { l: "Invested. Like I'm building something for the long run.", sc: { futureProof: 3 } },
        { l: 'Clean. Like I wiped the slate and started over.', sc: { reset: 3 } }
      ]
    }
  ];

  /* ---- Klaviyo property keys (one per question, in order) ----
     These become the property names on the captured event,
     which is what you'll segment against in flows. */
  var ANSWER_KEYS = [
    'skin_type',             // Q1
    'primary_concern',       // Q2
    'end_of_day_feel',       // Q3
    'skincare_relationship', // Q4
    'uses_actives',          // Q5
    'biggest_frustration',   // Q6
    'ideal_routine_feel'     // Q7
  ];

  /* ---- Product data cache ---- */
  var productCache = {};

  function fetchProductData(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.json')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var product = data.product;
        var result = {
          price: product.variants[0].price,
          image: product.featured_image
        };
        productCache[handle] = result;
        return result;
      })
      .catch(function() {
        return { price: null, image: null };
      });
  }

  function formatPrice(price) {
    if (!price) return '';
    var num = parseFloat(price);
    return '$' + num.toFixed(2);
  }

  /* ---- Cart API ---- */
 function addToCart(variantId, button) {
  var originalText = button.textContent;
  button.textContent = 'ADDING...';
  button.disabled = true;

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-drawer'],
      sections_url: window.location.pathname
    })
  })
  .then(function(res) { return res.json(); })
  .then(function(response) {
    button.textContent = '\u2713 ADDED';
    button.classList.add('fye-product__add--added');
    button.classList.add('fye-bundle__cta--added');

    if (response.sections && response.sections['cart-drawer']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = response.sections['cart-drawer'];

      /* Update drawer body — preserves the web component, only swaps content */
      var newBody = tmp.querySelector('#CartDrawer-Body');
      var existingBody = document.getElementById('CartDrawer-Body');
      if (newBody && existingBody) {
        existingBody.innerHTML = newBody.innerHTML;
      }

      /* Update item counter in drawer title */
      var newCounter = tmp.querySelector('.cart-drawer__title-counter');
      var existingCounter = document.querySelector('.cart-drawer__title-counter');
      if (newCounter && existingCounter) {
        existingCounter.textContent = newCounter.textContent;
      }

      /* Update badge in header */
      var badge = document.querySelector('.cart-count-badge');
      if (badge && newCounter) {
        badge.textContent = newCounter.textContent;
        badge.classList.remove('hidden');
      }
    }
  })
  .catch(function() {
    button.textContent = originalText;
    button.disabled = false;
  });
}

  /* ---- Quiz State ---- */
  var state = {
    view: 'welcome',
    qi: 0,
    scores: { minimalist: 0, glow: 0, futureProof: 0, repair: 0, reset: 0 },
    history: [],
    answers: [],          /* selected answer label for each question, in order */
    email: null,          /* captured email (or null if skipped/identified) */
    result: null,
    selectedOption: null,
    addedItems: {}
  };

  var container;

  /* ---- Klaviyo Helpers ----
     Uses the standard _learnq queue pattern. If Klaviyo's script hasn't
     loaded yet, the array buffers events; when Klaviyo loads, it replaces
     the array with its real queue and processes anything we pushed. */
  function klaviyoPush(args) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(args);
    } catch (e) {
      console.warn('[FYE] Klaviyo push failed:', e);
    }
  }

  function buildEventProps() {
    var ed = EDITS[state.result];
    var props = {
      recommended_edit: ed ? ed.name : null,
      recommended_products: ed ? ed.products.map(function(p) { return p.handle; }) : []
    };
    state.answers.forEach(function(answerLabel, i) {
      if (ANSWER_KEYS[i]) {
        props[ANSWER_KEYS[i]] = answerLabel;
      }
    });
    if (state.email) {
      props.email = state.email;
    }
    return props;
  }

  function fireQuizCaptured(email) {
    /* If a fresh email was provided, identify first so the event attaches
       to the right (or new) profile. For already-identified users we skip
       identify — Klaviyo's cookie handles attribution. */
    if (email) {
      klaviyoPush(['identify', { '$email': email }]);
    }
    klaviyoPush(['track', 'Quiz Email Captured', buildEventProps()]);
  }

  /* ---- Render Helpers ---- */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function(key) {
        if (key === 'className') node.className = attrs[key];
        else if (key === 'innerHTML') node.innerHTML = attrs[key];
        else if (key.indexOf('on') === 0) node.addEventListener(key.slice(2).toLowerCase(), attrs[key]);
        else node.setAttribute(key, attrs[key]);
      });
    }
    if (children) {
      if (typeof children === 'string') node.textContent = children;
      else if (Array.isArray(children)) children.forEach(function(c) { if (c) node.appendChild(c); });
      else node.appendChild(children);
    }
    return node;
  }

  function logoEl(light, size) {
    var logoSrc = light ? window.FYE_LOGO_BEIGE : window.FYE_LOGO_BLACK;
    if (!logoSrc) return el('div');
    var img = el('img', {
      src: logoSrc,
      alt: 'Seoul Beauty Edit',
      className: 'fye-logo ' + (light ? 'fye-logo--light' : 'fye-logo--dark')
    });
    if (size) img.style.width = size + 'px';
    return img;
  }

  /* ---- Screen Renderers ---- */

  function renderWelcome() {
    container.innerHTML = '';
    var screen = el('div', { className: 'fye-welcome' }, [
      logoEl(true, 180),
      el('h1', { className: 'fye-welcome__heading' }, 'FIND YOUR EDIT'),
      el('p', { className: 'fye-welcome__subtitle' }, '[ YOUR SKIN, YOUR LIFESTYLE, YOUR EDIT. ]'),
      el('p', { className: 'fye-welcome__body' }, 'Answer a few quick questions and we\'ll match you with a curated routine, chosen with intention, so skincare feels simple, not overwhelming.'),
      el('button', { className: 'fye-welcome__cta', onClick: function() { state.view = 'quiz'; render(); } }, 'BEGIN'),
      el('p', { className: 'fye-welcome__footer' }, 'TAKES ABOUT 2 MINUTES')
    ]);
    container.appendChild(screen);
  }

  function renderQuestion() {
    container.innerHTML = '';
    var question = QUESTIONS[state.qi];
    var pct = ((state.qi + 1) / QUESTIONS.length) * 100;

    var panel = el('div', { className: 'fye-question__panel' }, [
  el('div', { className: 'fye-question__step-number' }, '0' + (state.qi + 1)),
  el('div', { className: 'fye-question__panel-logo' }, logoEl(false, 100))
]);

    var progressHeader = el('div', { className: 'fye-progress__header' }, [
      el('span', { className: 'fye-progress__label' }, '[ QUESTION ' + (state.qi + 1) + ' OF ' + QUESTIONS.length + ' ]'),
      el('span', { className: 'fye-progress__pct' }, Math.round(pct) + '%')
    ]);

    var fill = el('div', { className: 'fye-progress__fill' });
    fill.style.width = pct + '%';

    var progress = el('div', { className: 'fye-progress' }, [
      progressHeader,
      el('div', { className: 'fye-progress__track' }, fill)
    ]);

    var options = el('div', { className: 'fye-options' });
    question.opts.forEach(function(opt, i) {
      var btn = el('button', {
        className: 'fye-option' + (state.selectedOption === i ? ' fye-option--selected' : ''),
        onClick: function() { selectOption(i); }
      }, opt.l);
      options.appendChild(btn);
    });

    var inner = el('div', { className: 'fye-question__inner' }, [
      progress,
      el('h2', { className: 'fye-question__title' }, question.q),
      el('p', { className: 'fye-question__sub' }, question.sub),
      options
    ]);

    if (state.qi > 0) {
      inner.appendChild(el('button', {
        className: 'fye-back',
        onClick: goBack
      }, '\u2190 PREVIOUS'));
    }

    var content = el('div', { className: 'fye-question__content' }, inner);
    var screen = el('div', { className: 'fye-question' }, [panel, content]);
    container.appendChild(screen);
  }

  /* ---- Email capture screen ---- */
  function renderEmail() {
    container.innerHTML = '';

    /* Left panel — matches question screens for visual continuity */
    var panel = el('div', { className: 'fye-question__panel' }, [
      el('div', { className: 'fye-question__step-number' }, '\u00B7\u00B7\u00B7'),
      el('div', { className: 'fye-question__panel-logo' }, logoEl(false, 100))
    ]);

    var headline = el('h2', { className: 'fye-question__title' }, 'GETTING YOUR EDIT READY');
    var sub = el('p', { className: 'fye-question__sub' }, 'Where should we send it?');

    /* Email input */
    var input = el('input', {
      type: 'email',
      inputmode: 'email',
      autocomplete: 'email',
      required: true,
      placeholder: 'you@example.com'
    });
    input.style.cssText = [
      'width:100%',
      'padding:13px 18px',
      'border:1px solid var(--fye-border, #e0ddd5)',
      'background:transparent',
      'font-family:var(--fye-body, "IBM Plex Serif", Georgia, serif)',
      'font-size:14px',
      'color:var(--fye-black, #0c0203)',
      'outline:none',
      'box-sizing:border-box',
      'margin-bottom:10px',
      'transition:border-color 0.15s ease'
    ].join(';');
    input.addEventListener('focus', function() {
      input.style.borderColor = 'var(--fye-black, #0c0203)';
    });
    input.addEventListener('blur', function() {
      input.style.borderColor = 'var(--fye-border, #e0ddd5)';
    });

    /* Inline error (hidden until needed) */
    var errorEl = el('p', null, '');
    errorEl.style.cssText = [
      'font-family:var(--fye-mono, "Roboto Mono", "Courier New", monospace)',
      'font-size:10px',
      'letter-spacing:1px',
      'color:#a23',
      'margin-bottom:10px',
      'min-height:14px',
      'display:none',
      'text-transform:uppercase'
    ].join(';');

    /* Consent text */
    var consent = el('p', null, "By continuing, you'll receive your edit and occasional emails from Seoul Beauty Edit. Unsubscribe anytime.");
    consent.style.cssText = [
      'font-family:var(--fye-mono, "Roboto Mono", "Courier New", monospace)',
      'font-size:9px',
      'letter-spacing:1.2px',
      'color:var(--fye-light, #a09e96)',
      'line-height:1.6',
      'margin-bottom:24px',
      'text-transform:uppercase'
    ].join(';');

    /* Primary CTA */
    var cta = el('button', null, 'SEND ME MY EDIT');
    cta.style.cssText = [
      'font-family:var(--fye-mono, "Roboto Mono", "Courier New", monospace)',
      'font-size:10px',
      'letter-spacing:4px',
      'padding:14px 40px',
      'background:var(--fye-black, #0c0203)',
      'color:var(--fye-white, #f9f9f9)',
      'border:none',
      'width:100%',
      'cursor:pointer',
      'text-transform:uppercase',
      'transition:background 0.2s ease',
      'margin-bottom:14px'
    ].join(';');
    cta.addEventListener('mouseenter', function() { cta.style.background = '#2a2020'; });
    cta.addEventListener('mouseleave', function() { cta.style.background = 'var(--fye-black, #0c0203)'; });

    function attemptSubmit() {
      var email = (input.value || '').trim();
      if (!email || !input.validity.valid) {
        errorEl.textContent = 'Please enter a valid email';
        errorEl.style.display = 'block';
        input.style.borderColor = '#a23';
        return;
      }
      handleEmailSubmit(email);
    }

    cta.addEventListener('click', attemptSubmit);
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); attemptSubmit(); }
    });

    /* Skip link — just advances, no event fired */
    var skip = el('button', null, 'No thanks, just show my edit');
    skip.style.cssText = [
      'font-family:var(--fye-mono, "Roboto Mono", "Courier New", monospace)',
      'font-size:9px',
      'letter-spacing:2px',
      'color:var(--fye-light, #a09e96)',
      'background:none',
      'border:none',
      'display:block',
      'margin:0 auto',
      'padding:8px',
      'text-transform:uppercase',
      'cursor:pointer'
    ].join(';');
    skip.addEventListener('click', handleEmailSkip);

    var inner = el('div', { className: 'fye-question__inner' }, [
      headline,
      sub,
      input,
      errorEl,
      consent,
      cta,
      skip
    ]);

    var content = el('div', { className: 'fye-question__content' }, inner);
    var screen = el('div', { className: 'fye-question' }, [panel, content]);
    container.appendChild(screen);

    /* Auto-focus on desktop only — avoids jarring keyboard popup on mobile */
    if (window.innerWidth > 768) {
      setTimeout(function() {
        try { input.focus(); } catch (e) {}
      }, 100);
    }
  }

  function handleEmailSubmit(email) {
    state.email = email;
    fireQuizCaptured(email);
    try { sessionStorage.setItem('fye_email', email); } catch (e) {}
    state.view = 'curating';
    render();
  }

  function handleEmailSkip() {
    state.view = 'curating';
    render();
  }

  function renderCurating() {
    container.innerHTML = '';

    var progressTrack = el('div', { className: 'fye-curating__track' });
    var progressFill = el('div', { className: 'fye-curating__fill' });
    progressTrack.appendChild(progressFill);

    var screen = el('div', { className: 'fye-curating' }, [
      logoEl(true, 120),
      el('p', { className: 'fye-curating__label' }, 'Curating your Edit\u2026'),
      progressTrack
    ]);

    container.appendChild(screen);

    /* Animate the progress bar across the full 2 seconds */
    requestAnimationFrame(function() {
      progressFill.style.transition = 'width 2s cubic-bezier(0.4, 0, 0.2, 1)';
      progressFill.style.width = '100%';
    });

    setTimeout(function() {
      state.view = 'results';
      render();
    }, 2000);
  }

  function renderTransition() {
  container.innerHTML = '';
  var ed = EDITS[state.result];

  var screen = el('div', { className: 'fye-transition' }, [
    logoEl(true, 180),
    el('p', { className: 'fye-transition__label' }, '[ BASED ON YOUR ANSWERS ]'),
    el('p', { className: 'fye-transition__sub' }, "WE'D RECOMMEND"),
    el('h1', { className: 'fye-transition__name' }, ed.name),
    el('div', { className: 'fye-transition__divider' })
  ]);
  container.appendChild(screen);

  setTimeout(function() {
    state.view = 'results';
    render();
  }, 2800);
}

  function renderResults() {
    container.innerHTML = '';
    var ed = EDITS[state.result];

    /* Header */
    var header = el('div', { className: 'fye-results__header' }, [
      logoEl(true, 120),
      el('p', { className: 'fye-results__header-label' }, '[ YOUR PERSONALIZED ROUTINE ]'),
      el('h1', { className: 'fye-results__header-name' }, ed.name),
      el('p', { className: 'fye-results__header-tag' }, ed.tag)
    ]);

    /* Description */
    var desc = el('div', { className: 'fye-results__desc' }, el('p', null, ed.desc));

    /* Products heading */
    var productsSection = el('div', { className: 'fye-products' });
    productsSection.appendChild(el('p', { className: 'fye-products__heading' }, "[ WHAT'S IN YOUR EDIT ]"));

    /* Product cards */
    ed.products.forEach(function(product, index) {
      var card = el('div', { className: 'fye-product' });
      var stepEl = el('div', { className: 'fye-product__step' }, String(product.step));
      var imgEl = el('div', { className: 'fye-product__image fye-product__image--loading' });
      var roleEl = el('p', { className: 'fye-product__role' }, product.role);
      var nameEl = el('p', { className: 'fye-product__name' }, product.name);
      var noteEl = el('p', { className: 'fye-product__note' }, product.note);

      var priceEl = el('span', { className: 'fye-product__price' });
      var priceLoading = el('span', { className: 'fye-product__price--loading' });
      priceEl.appendChild(priceLoading);

      var addBtn = el('button', { className: 'fye-product__add' }, '+ ADD TO CART');
      if (state.addedItems['product_' + index]) {
        addBtn.textContent = '\u2713 ADDED';
        addBtn.classList.add('fye-product__add--added');
      }
      addBtn.addEventListener('click', function() {
        addToCart(product.variantId, addBtn).then(function() {
          state.addedItems['product_' + index] = true;
        });
      });

      var actionsEl = el('div', { className: 'fye-product__actions' }, [priceEl, addBtn]);
      var infoEl = el('div', { className: 'fye-product__info' }, [roleEl, nameEl, noteEl, actionsEl]);

      card.appendChild(stepEl);
      card.appendChild(imgEl);
      card.appendChild(infoEl);
      productsSection.appendChild(card);

      fetchProductData(product.handle).then(function(data) {
        if (data.price) {
          priceEl.innerHTML = '';
          priceEl.textContent = formatPrice(data.price);
        }
        if (data.image) {
          var img = el('img', {
            src: data.image,
            alt: product.name,
            className: 'fye-product__image'
          });
          card.replaceChild(img, imgEl);
        }
      });
    });

    /* Bundle CTA */
    var bundlePrice = el('div', { className: 'fye-bundle__price-wrap' });
var bundlePriceLoading = el('span', { className: 'fye-bundle__price--loading' });
bundlePrice.appendChild(bundlePriceLoading);

    var bundleCta = el('button', { className: 'fye-bundle__cta' }, 'ADD COMPLETE EDIT TO CART');
    if (state.addedItems['bundle']) {
      bundleCta.textContent = '\u2713 ADDED';
      bundleCta.classList.add('fye-bundle__cta--added');
    }
    bundleCta.addEventListener('click', function() {
      addToCart(ed.bundleVariantId, bundleCta).then(function() {
        state.addedItems['bundle'] = true;
      });
    });

    var bundleCard = el('div', { className: 'fye-bundle__card' }, [
      bundlePrice,
      el('p', { className: 'fye-bundle__label' }, 'SAVE 10% AS A COMPLETE EDIT'),
      bundleCta
    ]);

    fetchProductData(ed.bundleHandle).then(function(data) {
  if (data.price) {
    var full = parseFloat(data.price);
    var discounted = (full * 0.9).toFixed(2);
    bundlePrice.innerHTML = '';
    bundlePrice.appendChild(el('span', { className: 'fye-bundle__price-original' }, formatPrice(data.price)));
    bundlePrice.appendChild(el('span', { className: 'fye-bundle__price-discounted' }, '$' + discounted));
  }
});

    var trustItems = [
      'Sourced from authorized Korean distributors',
      '14-day returns on unopened items',
      'Ships in 1\u20132 business days from the US'
    ];
    var trust = el('div', { className: 'fye-trust' });
    trustItems.forEach(function(text) {
      trust.appendChild(el('span', { className: 'fye-trust__item' }, '\u2713 ' + text));
    });

    var retake = el('div', { className: 'fye-retake' },
      el('button', { className: 'fye-retake__btn', onClick: restart }, 'RETAKE QUIZ')
    );

    var bundle = el('div', { className: 'fye-bundle' }, [bundleCard, trust, retake]);
    var screen = el('div', { className: 'fye-results' }, [header, desc, productsSection, bundle]);
    container.appendChild(screen);
  }

  /* ---- Quiz Logic ---- */

  function selectOption(index) {
    state.selectedOption = index;
    render();

    setTimeout(function() {
      var question = QUESTIONS[state.qi];
      var sc = question.opts[index].sc;

      state.history.push({
        minimalist: state.scores.minimalist,
        glow: state.scores.glow,
        futureProof: state.scores.futureProof,
        repair: state.scores.repair,
        reset: state.scores.reset
      });

      Object.keys(sc).forEach(function(key) {
        state.scores[key] = (state.scores[key] || 0) + sc[key];
      });

      /* Track which answer was selected for Klaviyo properties */
      state.answers.push(question.opts[index].l);

      state.selectedOption = null;

      if (state.qi < QUESTIONS.length - 1) {
        var screenEl = container.querySelector('.fye-question');
        if (screenEl) screenEl.classList.add('fye-question--fading');
        setTimeout(function() {
          state.qi++;
          render();
        }, 300);
      } else {
        var winner = Object.entries(state.scores).sort(function(a, b) { return b[1] - a[1]; })[0][0];
        state.result = winner;
        state.view = 'email';
        render();
      }
    }, 350);
  }

  function goBack() {
    if (state.qi > 0 && state.history.length > 0) {
      state.scores = state.history.pop();
      state.answers.pop();    /* keep answers in sync with question index */
      state.qi--;
      render();
    }
  }

  function restart() {
    state.view = 'welcome';
    state.qi = 0;
    state.scores = { minimalist: 0, glow: 0, futureProof: 0, repair: 0, reset: 0 };
    state.history = [];
    state.answers = [];
    state.email = null;
    state.result = null;
    state.selectedOption = null;
    state.addedItems = {};
    render();
  }

  /* ---- Main Render ---- */
  function render() {
    switch (state.view) {
      case 'welcome':    renderWelcome();    break;
      case 'quiz':       renderQuestion();   break;
      case 'email':      renderEmail();      break;
      case 'curating':   renderCurating();   break;
      case 'transition': renderTransition(); break;
      case 'results':    renderResults();    break;
    }
  }

  /* ---- Init ---- */
  function init() {
    container = document.getElementById('fye-quiz-container');
    if (!container) return;
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();